import { TActions } from '../../types';
import { PUBLISH_OFFER_FAIL, PUBLISH_OFFER_START, PUBLISH_OFFER_SUCCESS } from './actions';
import { defaultState } from './defaultState';
import { EPublishOfferStatus, IPublishInfoState } from './types';

export function publishInfo(state: IPublishInfoState = defaultState, action: TActions): IPublishInfoState {
  switch (action.type) {
    case PUBLISH_OFFER_START: {
      return {
        ...state,
        status: EPublishOfferStatus.pending,
        errorCode: null,
        errorMessage: null,
        errors: null,
      };
    }

    case PUBLISH_OFFER_SUCCESS: {
      return {
        ...state,
        status: EPublishOfferStatus.success,
      };
    }

    case PUBLISH_OFFER_FAIL: {
      return {
        ...defaultState,
        status: EPublishOfferStatus.fail,
        ...action.payload,
      };
    }

    default:
      return state;
  }
}
